import {
    GET_DOCUMENT_VERSIONS,
    GET_DRAFT_STATE,
    GET_DOCUMENT_VERSION_DETAIL,
    RECONSTRUCT_DOCUMENT_VERSION,
    CAPTURE_DOCUMENT_CHANGES,
    DISCARD_DOCUMENT_DRAFT,
    RESTORE_DOCUMENT_VERSION,
    RESET_DOCUMENT_VERSIONS,
} from './documentVersion.types';

/** Fetch published version list for a resource. */
export const getDocumentVersions = (params) => ({
    type: GET_DOCUMENT_VERSIONS,
    payload: { params },
});

/** Fetch working draft state (unsaved deltas). */
export const getDraftState = (params) => ({
    type: GET_DRAFT_STATE,
    payload: { params },
});

/** Fetch full deltas of one version (expandable row). */
export const getDocumentVersionDetail = (id) => ({
    type: GET_DOCUMENT_VERSION_DETAIL,
    payload: { id },
});

/** Reconstruct full form state at a version (read-only preview). */
export const reconstructDocumentVersion = (params) => ({
    type: RECONSTRUCT_DOCUMENT_VERSION,
    payload: { params },
});

/** Record pending edits into the open draft (fire-and-forget on blur). */
export const captureDocumentChanges = (body) => ({
    type: CAPTURE_DOCUMENT_CHANGES,
    payload: { body },
});

/** Discard the open draft (drop unsaved changes). */
export const discardDocumentDraft = (params) => ({
    type: DISCARD_DOCUMENT_DRAFT,
    payload: { params },
});

/** Restore an earlier version (creates a new version). */
export const restoreDocumentVersion = (body) => ({
    type: RESTORE_DOCUMENT_VERSION,
    payload: { body },
});

/** Reset all documentVersion state (used on unmount / navigation). */
export const resetDocumentVersions = () => ({
    type: RESET_DOCUMENT_VERSIONS,
});
